import { HOT } from "@hot-wallet/sdk";
import WebApp from "@twa-dev/sdk";
import { t } from "i18next";
import { useState } from "react";
import { mutate } from "swr";

import { ToastService } from "@/components/ToastService";
import { API_ERROR, TOAST_ID } from "@/constants";
import { API_ROUTES, STATUS_CODES } from "@/interfaces/api";
import { Network } from "@/interfaces/network";
import { hapiApi } from "@/services/api/hapi";
import { delay } from "@/utils";

import { useStore } from "./store";
import { useNetworkDependentActions } from "./useNetworkDependentActions";
const init = WebApp.initDataUnsafe;

export const useLevelActions = (mutateScore?: () => void) => {
  const { user, updateNews, network } = useStore((store) => ({
    user: store.user,
    updateNews: store.readNews,
    network: store.network,
  }));

  const [minting, setMinting] = useState(false);
  const [mintingNFT, setMintingNFT] = useState(false);
  const [reMinting, setReMinting] = useState(false);

  const networkActions = useNetworkDependentActions();

  const reMint = async () => {
    setReMinting(true);
    const success = await networkActions.reMint();
    if (success && network !== Network.TON && network !== Network.TON_TESTNET && network !== Network.SOLANA) {
      await mutate(`${API_ROUTES.USER}/${user.nearAccount}`);
    }
    setReMinting(false);
    await delay(3000);
    ToastService.clear(TOAST_ID.MINT);
  };

  const mint = async () => {
    setMinting(true);
    const success = await networkActions.mint();
    if (success && network !== Network.TON && network !== Network.TON_TESTNET && network !== Network.SOLANA) {
      await delay(2000);
      await mutate(`${API_ROUTES.USER}/${user.nearAccount}`);
    }
    setMinting(false);
    await delay(3000);
    ToastService.clear(TOAST_ID.MINT);
  };

  const mintNFT = async () => {
    setMintingNFT(true);
    const success = await networkActions.mintNFT();
    await delay(5000);
    success && (await mutate(`${API_ROUTES.USER}/${user.nearAccount}`));
    success && mutateScore?.();
    setMintingNFT(false);
  };

  const readNews = () => {
    if (!user.nearAccount || !user.news) return;
    window.open(user.news);
    updateNews();
    hapiApi.readNews({ address: user.nearAccount });
  };

  const connectTelegram = async () => {
    const connection = await HOT.connection;
    if (!user.nearAccount || !connection?.telegramId) return false;
    const response = await hapiApi.connectTelegram({
      address: user.nearAccount,
      telegramId: init.user?.id || connection.telegramId,
    });

    if (response.status === STATUS_CODES.CREATED) {
      mutate(`${API_ROUTES.USER}/${user.nearAccount}`);
      return true;
    }

    if (!("message" in response.data)) return false;

    if (response.data.message === API_ERROR.TELEGRAM_ALREADY_REGISTERED) {
      ToastService.simple({ text: t("Messages.TelegramAlreadyRegistered") });
    } else {
      ToastService.simple({ text: response.data.message });
    }
    return false;
  };

  const connectX = async () => {
    if (!user.nearAccount) return null;
    return hapiApi.connectTwitter({ address: user.nearAccount });
  };

  const connectWallet = async () => {
    if (networkActions.connectNetwork) {
      return networkActions.connectNetwork();
    }
  };

  return {
    minting,
    mintingNFT,
    reMinting,
    reMint,
    mint,
    mintNFT,
    readNews,
    connectTelegram,
    connectX,
    connectWallet,
  };
};
